import { render, staticRenderFns } from "./NewFolder.vue?vue&type=template&id=ca16e660&scoped=true"
import script from "./NewFolder.vue?vue&type=script&lang=js"
export * from "./NewFolder.vue?vue&type=script&lang=js"
import style0 from "./NewFolder.vue?vue&type=style&index=0&id=ca16e660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca16e660",
  null
  
)

export default component.exports